import React, { useState } from "react";

export function Avatar({ src, name, size = 36 }) {
  const [err, setErr] = useState(false);
  const initial = name ? name[0].toUpperCase() : "?";
  const style = { width: size, height: size };
  if (src && !err) {
    return (
      <img src={src} alt={name || "Avatar"} referrerPolicy="no-referrer" onError={() => setErr(true)}
        style={style} className="rounded-full object-cover" data-testid="user-avatar-img" />
    );
  }
  return (
    <div style={style} className="rounded-full bg-[#1F4FE0] text-white flex items-center justify-center font-semibold" data-testid="user-avatar-initial">
      {initial}
    </div>
  );
}
